import React, { ChangeEvent } from "react";
import { MdDelete } from "react-icons/md";
import { getBase64OfImage } from "../../helper/functions";
import { StyledFileUploader } from "./styled";

interface Props {
  setValue: (value: string) => void;
  fileName: string;
  setFileName: (value: string) => void;
  name: string;
}

const FileUploader: React.FC<Props> = ({
  setValue,
  fileName,
  name,
  setFileName,
}) => {
  return (
    <>
      <StyledFileUploader>
        <label htmlFor={name}>{fileName || "Choose " + name}</label>
        <input
          id={name}
          style={{ visibility: "hidden", height: 0, width: 0 }}
          type={"file"}
          accept=".png,.jpeg,.jpg"
          value={""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (!e.target.files?.length) {
              return;
            }
            setFileName(e.target.files[0].name);

            getBase64OfImage(e.target.files[0])
              .then((base64: string) => {
                setValue(base64);
                e.target.value = "";
              })
              .catch(() => {
                e.target.value = "";
              });
          }}
        />
        {fileName && (
          <MdDelete
            onClick={() => {
              setFileName("");
              setValue("");
            }}
          />
        )}
      </StyledFileUploader>
    </>
  );
};

export default FileUploader;
